import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import {
  PrismButton,
  PrismCard,
  PrismMessage,
} from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import SkeletonTableIllustration from 'lumen/assets/images/benchmark-insight/skeleton/skeleton-table.svg?raw';
import HotelBenchmarkInsightCardOverlay from 'lumen/components/hotel/benchmark-insight/card-overlay';
import HotelBenchmarkInsightSkeleton from 'lumen/components/hotel/benchmark-insight/skeleton';
import HotelBenchmarkInsightUpsellIcon from 'lumen/components/hotel/benchmark-insight/upsell-icon';

interface HotelBenchmarkInsightSectionsSectionBreakdownsSignature {
  Args: {};
}

export default class HotelBenchmarkInsightSectionsSectionSegmentSectionSegmentOverlay extends Component<HotelBenchmarkInsightSectionsSectionBreakdownsSignature> {
  @service('benchmark-insight/features')
  declare benchmarkInsightFeatures: Services['benchmark-insight/features'];
  @service('benchmark-insight/trial')
  declare benchmarkInsightTrial: Services['benchmark-insight/trial'];

  <template>
    <PrismCard @contentLayout="noPadding">
      <:header>
        <div class="flex items-center gap-200">
          <HotelBenchmarkInsightUpsellIcon
            @tooltipText={{this.benchmarkInsightFeatures.beniLightSegmentationTooltipText}}
          />

          <h4 class="text-400--bold">
            {{t "benchmark_insight.breakdowns"}}
          </h4>
        </div>
      </:header>

      <:content>
        <div class="relative">
          <HotelBenchmarkInsightSkeleton
            @imageHtml={{SkeletonTableIllustration}}
            @showAnimation={{false}}
          />

          <HotelBenchmarkInsightCardOverlay>
            <PrismMessage
              @description={{t
                "benchmark_insight.light.breakdowns.overlay.message"
              }}
              @illustration="100x100_rocket"
              @title={{t "benchmark_insight.light.breakdowns.overlay.title"}}
            >
              <:primaryAction>
                <PrismButton
                  @buttonType="brand"
                  @iconAfter="arrow-right"
                  @label={{t "benchmark_insight.light.get_in_touch"}}
                  @onClick={{this.benchmarkInsightTrial.onClickStartTrial}}
                />
              </:primaryAction>
            </PrismMessage>
          </HotelBenchmarkInsightCardOverlay>
        </div>
      </:content>
    </PrismCard>
  </template>
}
